'use client';

import { API_ROUTES, createQueryKey, useApiMutation } from '@shared/api-utils';
import { useQueryClient } from '@tanstack/react-query';
import type { UpdatePlayerProfileData } from '../types';

function useUpdatePlayerProfile() {
  const queryClient = useQueryClient();

  return useApiMutation<{ success: boolean }, UpdatePlayerProfileData>(API_ROUTES.MY_ACCOUNT.PLAYER_PROFILE.PATCH, 'PATCH', {
    mutationOptions: {
      onSuccess: () => {
        // Override the default behavior to only invalidate the profile query
        // The default useApiMutation invalidates all ['api'] queries
        // We want to prevent the verification endpoint from being refetched here
        queryClient.invalidateQueries({ queryKey: createQueryKey(API_ROUTES.MY_ACCOUNT.PLAYER_PROFILE.GET) });
      },
    },
  });
}

export { useUpdatePlayerProfile };
